<template>
  <div class="language-bd bd">
    <div class="aside">
      <div class="title">
        <i class="icon icon-langset"></i>
        <span>{{ $t('base_language.duo_yu_yan_she_zhi') }}</span>
      </div>
      <div class="search">
        <custom-select
          isDefault
          v-model="appId"
          url="AppMenu"
          :clearable="false"
          :props="{ label: 'appName', value: 'appId' }"
          :placeholder="$t('Common.com_please_select')"
          width="100%"
          style="margin-bottom: 14px; vertical-align: top"
          @change="selectApp"
        ></custom-select>
        <custom-select
          isDefault
          v-model="langCode"
          code="language_type"
          :clearable="false"
          :props="{ label: 'name', value: 'value' }"
          width="100%"
          :placeholder="$t('Common.com_please_select')"
          style="margin-bottom: 14px; vertical-align: top"
          @change="selectLangCode"
        ></custom-select>
      </div>
      <div class="tree">
        <el-collapse v-model="collapse" accordion>
          <el-collapse-item :title="item.name" :name="index" v-for="(item, index) in appTree" :key="index">
            <el-input style="margin-bottom: 12px" :placeholder="$t('base_language.fen_zu_ming_cheng')" v-model="item.keyWords" @input="filterTree($event, index)" clearable></el-input>

            <el-tree
              ref="tree"
              :data="item.children"
              :props="treeProps"
              node-key="id"
              :highlight-current="true"
              :default-expanded-keys="expandedKeys"
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              :filter-node-method="filterNode"
            >
              <span class="tree-item" slot-scope="{ data }">
                <span class="line1">{{ data.name }}</span>
              </span>
            </el-tree>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="section">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="primary" icon="el-icon-download" v-if="funcView.import_lang_data">{{ funcView.import_lang_data }}</el-button>
            <input v-if="showUpload" style="opacity: 0; position: absolute; left: 0; bottom: 0; top: 0; width: 100%" type="file" name="excel" @change="handleUpload" />
          </el-form-item>
          <el-form-item>
            <el-button v-if="funcView.export_lang_data" type="primary" icon="el-icon-upload2" @click="exportTable">{{ funcView.export_lang_data }}</el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('base_language.jmcdmmrz')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <el-select v-model="formSearch.translateStatus" :placeholder="$t('base_language.shi_fou_fan_yi')" clearable @change="onPageChange({ page: 1 })" style="width: 120px; vertical-align: top">
              <el-option v-for="item in translateStatus" :key="item.id" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table v-if="funcView.lang_config_list" tableCode="langConfig" :data="langItemList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%">
          <el-table-column :label="$t('Common.com_handle')" fixed="right">
            <template slot-scope="scope">
              <el-button @click="editLangItem(scope.row)" type="text" size="mini" v-if="funcView.language_config_setup">{{ funcView.language_config_setup }}</el-button>
            </template>
          </el-table-column>
        </custom-table>
      </div>
      <div class="table-page" v-if="funcView.lang_config_list">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <!-- 编辑配置弹窗 -->
    <lang-config-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getLangItemPage"></lang-config-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import langConfigDialog from './children/language_config_dialog';

export default {
  name: 'language',
  components: { langConfigDialog },
  data() {
    return {
      showUpload: true,
      collapse: '',
      appId: '',
      langCode: '',
      languageTypes: [],
      appTree: [],
      langData: {},
      expandedKeys: [],
      langKeyTypes: [],

      dialogVisible: false,
      dialogModel: {},
      translateStatus: [],
      formSearch: {
        keyId: '',
        langCode: '',
        keyTypeCode: '',
        translateStatus: '',
        search: '',
        pageSize: 50,
        pageNum: 1,
      },

      langItemList: [],
      totalRows: 0,
      isLoading: false,
      treeProps: {
        children: 'children',
        label: 'name',
      },
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getDictionary1();
    this.getFuncView();
  },
  methods: {
    // 选择平台
    selectApp: function () {
      const search = this.formSearch.search;
      const translateStatus = this.formSearch.translateStatus;
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.search = search;
      this.formSearch.translateStatus = translateStatus;
      this.langItemList = [];
      this.totalRows = 0;
      this.appTree = [];
      this.langData = {};
      this.expandedKeys = [];
      this.collapse = '';
      this.getAppTree();
      if (this.appId && this.langCode) {
        this.onPageChange({ page: 1 });
      }
    },
    // 选择语言
    selectLangCode: function () {
      if (this.appId && this.langCode) {
        this.onPageChange({ page: 1 });
      }
    },
    // 下拉选择列表
    getDictionary1: function () {
      this.$getJSON(apis.DictionaryCode, {
        groupCodes: 'language_type,bas_translate_status,bas_lang_key_type',
      }).then((res) => {
        this.languageTypes = res.data.language_type || [];
        this.translateStatus = res.data.bas_translate_status || [];
        this.langKeyTypes = res.data.bas_lang_key_type || [];
      });
    },
    // 获取平台多语言树
    getAppTree: function () {
      this.$getJSON(apis.LanguageTree, { appId: this.appId }).then((res) => {
        const appTree = res.data || [];
        appTree.forEach((t) => {
          t.keyWords = '';
        });
        this.appTree = appTree;
      });
    },
    // 选中树字典项
    handleNodeClick: function (row) {
      this.expandedKeys = [row.id];
      this.langData = row;
      const search = this.formSearch.search;
      const translateStatus = this.formSearch.translateStatus;
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.search = search;
      this.formSearch.translateStatus = translateStatus;
      this.appTree.forEach((item, index) => {
        this.$refs.tree[index].setCurrentKey(null);
        this.$refs.tree[index].setCurrentKey(this.langData.id);
      });
      this.getLangItemPage();
    },
    // 搜索过滤事件
    filterTree: function (value, index) {
      this.$refs.tree[index].filter(value);
    },
    // 搜索过滤
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    // 获取字典项列表
    getLangItemPage: function () {
      if (!this.appId || !this.langCode) {
        return;
      }
      this.formSearch.appId = this.appId;
      this.formSearch.langCode = this.langCode;
      this.formSearch.keyId = this.langData.id;
      this.formSearch.keyTypeCode = this.langData.value;
      this.isLoading = true;
      this.$getJSON(apis.LanguagePage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.langItemList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 编辑配置
    editLangItem: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_language.duo_yu_yan_she_zhi');
      this.dialogModel.data = {
        langKeyCode: this.langCode,
        langKeyTypes: this.langKeyTypes,
        languageTypes: this.languageTypes,
        row: data,
      };
      this.dialogVisible = true;
    },
    // 数据上传
    handleUpload: function (file) {
      this.$postFile(apis.LanguageImport, file)
        .then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.resetUpload();
        })
        .catch(() => {
          this.resetUpload();
        });
    },
    resetUpload: function () {
      this.showUpload = false;
      setTimeout(() => {
        this.showUpload = true;
      }, 1000);
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.LanguageExport, {
        appId: this.appId,
        keyGroupId: this.langData.id,
      }).then(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLangItemPage();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';

.language-bd {
  .aside {
    width: 270px !important;
    .search {
      margin-bottom: 0 !important;
    }
    .tit .el-input--mini .el-input__inner {
      @include color_main();
    }
    .el-collapse-item__content {
      padding-bottom: 0;
    }
    .el-collapse {
      border-top: none;
      border-bottom: none;
    }
    .el-collapse-item {
      margin-bottom: 10px;
      &.is-active .el-collapse-item__header {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .el-collapse-item__header {
      @include background_color_main();
      //  background:rgba(68,133,166,1);
      border-radius: 2px 2px 0px 0px;
      // border:1px solid rgba(68,133,166,1);
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      color: #ffffff;
      font-size: 12px;
      font-weight: normal;
      border-radius: 2px;
      border-bottom: none;
    }
    .tree {
      background-color: transparent;
      overflow-y: inherit !important;
      .el-collapse {
        display: flex;
        flex-direction: column;
        height: 100%;
        .el-collapse-item.is-active {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          // overflow-y:inherit !important;
          // margin-bottom:10px;
          .el-collapse-item__wrap {
            flex: 1;
            overflow-y: auto;
            border: 1px solid rgba(0, 0, 0, 0.1);
            margin-top: 10px;
            border-radius: 2px;
            //  border-top:node ;
            .el-collapse-item__content {
              // padding-top: 13px;
            }
          }
        }
      }
    }
    .el-collapse-item__wrap {
      padding: 14px;
      // background-color: #f9f9fd;
      border-bottom: none;
    }
    .tree .el-tree-node__content {
      height: 32px !important;
      line-height: 32px !important;
      // &:hover {
      //   background-color: #eef2f8 !important;
      // }
    }
  }
  .section {
    margin-left: 270px !important;
    .title {
      color: #404040;
      font-size: 16px;
      line-height: 24px;
      padding-top: 10px;
      font-weight: bold;
      i {
        font-weight: normal;
        margin-right: 5px;
        color: #404040;
      }
    }
    .info-bd {
      padding: 11px 10px 5px;
      height: 66px;

      .label {
        color: #727272;
        font-size: 12px;
        line-height: 17px;
      }
      .value {
        color: #404040;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}
</style>
